<template>
  <div class="wrapper full-width">
    <app-header :back="back"></app-header>
    <main class="content">
      <header class="page">
        <h1 class="title">Contact Us</h1>
      </header>
      <form class="form">
        <div class="form-row">
          <label for="contact-name" class="form-label">Name</label>
          <div class="input-group" :class="{ 'has-error': $v.name.$error, 'is-valid': $v.name.required }">
            <input id="contact-name" type="text" class="form-control" v-model.trim="$v.name.$model" autofocus>
            <div class="error" v-if="!$v.name.required">Name is required</div>
          </div>
        </div>
        <div class="form-row">
          <label for="contact-email" class="form-label">Email</label>
          <div class="input-group" :class="{ 'has-error': $v.email.$error, 'is-valid': $v.email.required && $v.email.email }">
            <input id="contact-email" type="text" class="form-control" v-model.trim="$v.email.$model">
            <div class="error" v-if="!$v.email.required">Email is required</div>
            <div class="error" v-if="!$v.email.email">Invalid email format</div>
          </div>
        </div>
        <div class="form-row">
          <label for="contact-phone" class="form-label">Phone</label>
          <div class="input-group">
            <input id="contact-email" type="text" class="form-control" v-mask="'###-###-####'" v-model="phone">
          </div>
        </div>
        <div class="form-row">
          <label for="contact-message" class="form-label">Message</label>
          <div class="input-group" :class="{ 'has-error': $v.message.$error, 'is-valid': $v.message.required }">
            <textarea id="contact-message" class="form-control" v-model.trim="$v.message.$model"></textarea>
            <div class="error" v-if="!$v.message.required">Message is required</div>
          </div>
        </div>
        <div class="form-row">
          <button class="btn btn-primary has-arrow" :disabled="$v.$invalid" @click.prevent="handleSubmit">Submit</button>
        </div>
        <p v-if="submitMessage">{{ submitMessage }}</p>
      </form>
    </main>
  </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import Header from '@/components/Header'
export default {
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      submitMessage: null,
      back: null
    }
  },
  components: {
    'app-header': Header
  },
  validations: {
    name: { required },
    email: { required, email },
    message: { required }
  },
  methods: {
    handleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitMessage = 'Please correct the fields with errors.'
      } else {
        this.submitMessage = 'Sending...'
        // send to WP
        axios.post(this.$store.state.storeDomain + '/wp-json/millborn/v1/contact/',
          {
            'Name': this.name,
            'Email': this.email,
            'Phone': this.phone,
            'Message': this.message
          },
          {
            headers: {
              'Content-type': 'application/json'
            }
          })
          .then(response => {
            if (response.data.result === 'success') {
              this.name = ''
              this.email = ''
              this.phone = ''
              this.message = ''
              this.$v.$reset()
              this.submitMessage = 'Thanks for your submission!'
            } else {
              this.submitMessage = 'Sorry, the message could not be sent.'
              // console.log(response.data.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.back = from.name // catch which page we came from
    })
  }
}
</script>
